<template>
    <modal id="status-export-modal"
           v-model="showModal"
           :btn-label="$t('export')"
           :title="$t('export')"
           @submit="submitData" :loading="loading"
           :preloader="preloader">
        <form ref="form" @submit.prevent="submitData">
            <app-form-group
                page="page"
                type="date"
                :label="$t('date')"
                v-model="queryObject.date"
                :placeholder="queryObject.date ? $placeholder('date') : this.$t('not_added_yet')"
            />
            <app-form-group
                page="page"
                type="select"
                :label="$t('type')"
                v-model="queryObject.export_type"
                :list="exportTypeOptions"
            />
            <app-form-group-selectable
                page="page"
                type="multi-select"
                :label="$t('floor')"
                list-value-field="name"
                list-value-id="id"
                v-model="queryObject.floors"
                form-group-class="status-export-floor"
                :chooseLabel="$t('floor')"
                :fetch-url="`${TENANT_BASE_URL}selectable/hotel/room?group=floor&format=floor&hotel_id=${hotel.id}`"
            />
        </form>
    </modal>
</template>

<script>
import FormHelperMixins from "../../../../../common/Mixin/Global/FormHelperMixins";
import ModalMixin from "../../../../../common/Mixin/Global/ModalMixin";
import {TENANT_BASE_URL} from "../../../../../common/Config/UrlHelper";
import {formatDateForServer, localTimeZone} from "../../../../../common/Helper/Support/DateTimeHelper";
import {urlGenerator} from "../../../../../common/Helper/AxiosHelper";

export default {
    name  : "StatusExportModal",
    mixins: [FormHelperMixins, ModalMixin],
    props : {
        hotel: {
            type   : Object,
            default: {},
        },
        filterDate: {
            type   : [String, Date],
            default: '',
        },
    },
    data() {
        return {
            TENANT_BASE_URL,
            queryObject: {
                floors     : [],
                date       : this.defaultDate(),
                export_type: 'excel',
            },
            exportTypeOptions: [
                {id: 'excel', value: 'Excel'},
                {id: 'pdf', value: 'PDF'},
            ],
        }
    },
    watch: {
        filterDate: {
            handler() {
                this.queryObject.date = this.defaultDate();
            },
            immediate: true,
        },
    },
    methods: {
        submitData() {
            this.loading = true;
            const date   = this.exportDate();
            const floors = Array.isArray(this.queryObject.floors) ? this.queryObject.floors.join(',') : '';
            const params = new URLSearchParams();

            if (date) params.append('date', date);
            if (floors) params.append('floors', floors);
            params.append('export_type', this.queryObject.export_type || 'excel');
            params.append('timeZone', localTimeZone);
            params.append('locale', window.appLanguage || window.localStorage.getItem('app-language') || 'en');

            window.location = urlGenerator(`${TENANT_BASE_URL}app/export/hotel/${this.hotel.id}/status?${params.toString()}`);

            this.queryObject = {
                floors     : [],
                date       : this.defaultDate(),
                export_type: 'excel',
            };
            $('#status-export-modal').modal('hide');
            this.$emit('input', false);
        },
        defaultDate() {
            return this.filterDate || formatDateForServer(new Date());
        },
        exportDate() {
            if (typeof this.queryObject.date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(this.queryObject.date)) {
                return this.queryObject.date;
            }

            return formatDateForServer(this.queryObject.date);
        },
        afterSuccessFromGetEditData() {
        },
    },
}
</script>

<style scoped>
::v-deep(.status-export-floor .chips-container) {
    min-height: 250px;
}
</style>
